import { useUser } from 'containers/user/hooks/useUser'
import { NotificationDTO, NotificationTypes } from '../types/notifications'
import {
  useProfileById,
  useProfileRelationType,
} from 'containers/profile/hooks/useProfile'
import { ProfileRelationType } from 'containers/profile/types/profile'

export const useNotificationsLikeUserInfo = (
  notification: Extract<
    NotificationDTO,
    { notificationType: NotificationTypes.LIKE }
  >
) => {
  const { user, isLoading } = useUser()

  const { profile: profileLiker, isLoading: loadingLikerProfile } =
    useProfileById(notification.specificData.userIdLiker)

  const isUserOwner = user?.id === notification.specificData.ownerId

  const { profile: profileOwner, isLoading: loadingOwnerProfile } =
    useProfileById(notification.specificData.ownerId)

  const userRelation = useProfileRelationType(profileLiker)

  const isLikerConnection =
    userRelation === ProfileRelationType.CONNECTION ||
    userRelation === ProfileRelationType.CONNECTION_REQUESTED

  const loadingProfiles =
    loadingLikerProfile || loadingOwnerProfile || isLoading

  return {
    loading: loadingProfiles,
    profileLiker,
    profileOwner,
    isUserOwner,
    isLikerConnection,
  }
}
